import React, { useContext, useEffect, useState } from 'react';
import { CiEdit } from 'react-icons/ci';

import SearchableDropDownCodeMozoeeChap from '../../../SearchableDropDown/SearchableDropDownCodeMozoeeChap.tsx';
import { DataContext } from '../../../context/DataProvider.tsx';
import { IoNewspaperOutline } from 'react-icons/io5';

const CardMozoatMonaghah = () => {
  const {
    isTokenExpired,
    tokenLogin,
    fetchRefreshToken,
    titleSubInfo,
    setTitleSubInfo,
    toggleSabt,
    setToggleSabt,
    typeIdTitSub,
    setTitChapterInfo,
    titChapterInfo,
    chapterSectionText,
    setChapterSectionText,
  } = useContext(DataContext);

  useEffect(() => {
    return () => {};
  }, [titChapterInfo, chapterSectionText]);

  const newSubFun = () => {
    try {
      setTitChapterInfo((prev) => ({
        ...prev,
        ID: 0,
        Title: '',
        Parent_ID: 0,
        // Definition: '',
        Code: '',
        Ordering: '',
        Type_ID: 0,
        // Keywords: '',
        Section_ID: '',

        MainLaw_IDs: '',

        IsActive: false,
        isChecked: false,
      }));
    } catch (error) {
      console.log('error', error);
    }
  };

  const upsertSubFun = async () => {
    if (!validateTitle(titChapterInfo.Title)) {
      // alert('لطفا عنوان را به درستی وارد نمایید');
      alert(
        'لطفا عنوان را به درستی وارد نمایید. عنوان نباید خالی باشد یا شامل کاراکترهای غیرمجاز (مانند ,!@#$%^&*)(_+-<>./) باشد.',
      );
      return;
    }
    if (!isTokenExpired(tokenLogin.data?.accessToken)) {
      try {
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/Subject/Upsert`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
            'Access-Control-Allow-Headers':
              'X-Requested-With, Content-Type, Authorization',
            'Access-Control-Allow-Credentials': 'true',
          },
          body: JSON.stringify({
            id: titChapterInfo.ID,
            title: titChapterInfo.Title,
            parent_ID: titChapterInfo.Parent_ID,
            definition: titChapterInfo.Definition,
            code: titChapterInfo.Code,
            ordering: titChapterInfo.Ordering,
            type_ID: titChapterInfo.Type_ID,
            keywords: titChapterInfo.Keywords,
            old_IDs: titChapterInfo.Old_IDs,
            mainLaw_IDs: titChapterInfo.MainLaw_IDs,
            section_ID: titChapterInfo.Section_ID,
            isActive: titChapterInfo.IsActive,
            isChecked: titChapterInfo.isChecked,
          }),
        }).then((res) => {
          // console.log(res.json());
          setToggleSabt(!toggleSabt);
          if (res.status === 200) {
            alert('ویرایش با موفقیت انجام شد');

            setTitChapterInfo((prev) => ({
              ...prev,
              ID: 0,
              Title: '',
              Parent_ID: 0,
              // Definition: '',
              Code: '',
              Ordering: '',
              Type_ID: 0,
              // Keywords: '',
              Section_ID: '',

              MainLaw_IDs: '',

              IsActive: false,
              isChecked: false,
            }));
          }
        });
      } catch (error) {
        console.log('error', error);
      }
    } else {
      fetchRefreshToken();
      // alert('برای شما دسترسی جدید صادر گردید، لطفا مجددا تلاش نمایید');
    }
  };

  // یک تابع برای اعتبارسنجی عنوان
  const validateTitle = (title: string) => {
    // حذف فضاهای خالی از ابتدا و انتها
    const trimmedTitle = title.trim();

    // چک کردن کاراکترهای غیرمجاز
    // const invalidChars = /[,!@#$%^&*)(_+-<>./\\]/;
    const invalidChars = /[,!@#$%^&)(_+-./\\]/;

    if (!trimmedTitle || invalidChars.test(trimmedTitle)) {
      return false;
    }
    return true;
  };

  return (
    <>
      <div className="card-with-scroll col-span-3 pb-10">
        <div className="w-full flex items-center justify-center">
          <div className="w-full  text-center mb-2 bg-[#a179c7] p-2 rounded-lg">
            <p className="font-IranSans text-sm text-white">
              <b> ویرایش ابواب و فصول کدهای موضوعی </b>
            </p>
            <p className="font-IranSans mr-3 text-sm"></p>
          </div>
        </div>
        <div className="max-w-full mx-auto ">
          <div className="border-b border-gray-200 dark:border-gray-700 mb-4"></div>

          <div className="w-full border rounded-md p-5 border-[#cbd5e1]">
            <div className="w-full grid grid-cols-2 gap-10 mt-5 ">
              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  عنوان
                </label>
                {/* <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  // value={titSubID.Title}
                  value={titChapterInfo?.Title}
                  onChange={(e) =>
                    setTitChapterInfo((caseData) => ({
                      ...caseData,
                      Title: e.target.value,
                    }))
                  }
                /> */}
                {/* // تغییر در onChange عنوان */}
                <input
                  type="text"
                  className="w-full border outline-none p-2 rounded-md"
                  value={titChapterInfo.Title}
                  onChange={(e) => {
                    // const newTitle = e.target.value;
                    // if (validateTitle(newTitle)) {
                    setTitChapterInfo((caseData) => ({
                      ...caseData,
                      Title: e.target.value,
                      // Title: newTitle,
                    }));
                    // } else {
                    //   alert(
                    //     'لطفا عنوان را به درستی وارد نمایید. عنوان نباید خالی باشد یا شامل کاراکترهای غیرمجاز (مانند ,!@#$%^&*)(_+-<>./) باشد.',
                    //   );
                    // }
                  }}
                />
              </div>

              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  ترتیب
                </label>
                <input
                  type="number"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titChapterInfo?.Ordering}
                  // value={}
                  onChange={(e) =>
                    setTitChapterInfo((caseData) => ({
                      ...caseData,
                      Ordering: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  کد
                </label>
                <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titChapterInfo?.Code}
                  // value={}
                  onChange={(e) =>
                    setTitChapterInfo((caseData) => ({
                      ...caseData,
                      Code: e.target.value,
                    }))
                  }
                />
              </div>

              {/* <div className="flex flex-col gap-1 mt-4"> */}
              <div className="w-full flex items-center  col-span-1	">
                {/* <label htmlFor="hs-hidden-select" className="text-gray-700 "> */}
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  {' '}
                  نوع
                </label>
                <div
                  //  className="relative"
                  className="w-full border  outline-none  p-2 rounded-md"
                >
                  <select
                    // {...register('Subject')}
                    // value={subjects}
                    defaultValue={
                      titleSubInfo.Type_ID !== null
                        ? typeIdTitSub.find(
                            (item) => item.id == titChapterInfo.Type_ID,
                          ) !== undefined
                          ? typeIdTitSub.find(
                              (item) => item.id == titChapterInfo.Type_ID,
                            ).id
                          : null
                        : null
                    }
                    onChange={(e) =>
                      setTitChapterInfo((caseData) => ({
                        ...caseData,
                        Type_ID: e.target.value,
                      }))
                    }
                    className=" w-full "
                  >
                    <option
                      className="font-extralight "
                      // selected
                      // value={0}
                      hidden
                      // value={titExecutive.State_ID}
                    >
                      {titChapterInfo.Type_ID !== null
                        ? typeIdTitSub.filter(
                            (item) => item.id == titChapterInfo.Type_ID,
                          )[0]?.item || ''
                        : ' انتخاب کنید '}
                      {/* انتخاب کنید */}
                    </option>
                    {typeIdTitSub ? (
                      typeIdTitSub.map((item) => {
                        return (
                          <option
                            className="font-extralight "
                            key={item.id}
                            value={item.id}
                          >
                            {item.item}
                          </option>
                        );
                      })
                    ) : (
                      <div>...</div>
                    )}
                  </select>
                </div>
              </div>

              <div className="w-full flex items-center justify-between mb-3">
                <label className="h-full w-[15%] text-[14px] flex items-start justify-start font-IranSans">
                  سرشاخه
                </label>
                <SearchableDropDownCodeMozoeeChap />
              </div>

              <div className="w-full flex items-center justify-between">
                <div className="flex items-center mb-4">
                  {/* <label
                    htmlFor="default-checkbo"
                    className="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                  >
                    فعال است{' '}
                  </label>
                  <input
                    onChange={(e) =>
                      setTitChapterInfo((caseData) => ({
                        ...caseData,
                        IsActive: e.target.checked,
                      }))
                    }
                    id="default-checkbo"
                    type="checkbox"
                    checked={titChapterInfo?.IsActive}
                    // value={titChapterInfo.IsActive}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  /> */}
                  <label
                    htmlFor="active-status"
                    className="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                  >
                    فعال{' '}
                  </label>
                  <select
                    id="active-status"
                    onChange={(e) =>
                      setTitChapterInfo((caseData) => ({
                        ...caseData,
                        IsActive:
                          e.target.value === 'true'
                            ? true
                            : e.target.value === 'false'
                            ? false
                            : null,
                      }))
                    }
                    value={titChapterInfo?.IsActive?.toString() ?? ''}
                    className="w-24 text-sm bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                  >
                    <option value="null">نامعلوم </option>
                    <option value="true">هست</option>
                    <option value="false">نیست</option>
                  </select>
                </div>
                <div className="flex items-center mb-4">
                  {/* <label
                    htmlFor="default-checkbox"
                    className="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                  >
                    تایید شده{' '}
                  </label>
                  <input
                    onChange={(e) =>
                      setTitChapterInfo((caseData) => ({
                        ...caseData,
                        isChecked: e.target.checked,
                      }))
                    }
                    id="default-checkbox"
                    type="checkbox"
                    checked={titChapterInfo?.isChecked}
                    // value={titChapterInfo.isChecked}
                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                  /> */}
                  <label
                    htmlFor="checked-status"
                    className="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                  >
                    مورد تایید{' '}
                  </label>
                  <select
                    id="checked-status"
                    onChange={(e) =>
                      setTitChapterInfo((caseData) => ({
                        ...caseData,
                        isChecked:
                          e.target.value === 'true'
                            ? true
                            : e.target.value === 'false'
                            ? false
                            : null,
                      }))
                    }
                    value={titChapterInfo?.isChecked?.toString() ?? ''}
                    className="w-24 text-sm bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                  >
                    <option value="null">نامعلوم</option>
                    <option value="true">هست</option>
                    <option value="false">نیست</option>
                  </select>
                </div>
              </div>
            </div>
            {/* <div className="mt-2">
              <div className="w-full flex items-center  col-span-1	">
                <label className="h-full w-[15%] text-[16px] flex items-center  font-IranSans">
                  شناسه های قوانین شاخص
                </label>
                <input
                  type="text"
                  className="w-full border  outline-none  p-2 rounded-md"
                  value={titChapterInfo?.MainLaw_IDs}
                  // value={}
                  onChange={(e) =>
                    setTitChapterInfo((caseData) => ({
                      ...caseData,
                      MainLaw_IDs: e.target.value,
                    }))
                  }
                />
              </div>
            </div> */}
            <div className="w-full h-full flex items-center ltr gap-5 mt-10">
              <button
                onClick={upsertSubFun}
                className="w-32 p-2  font-IranSans rounded-full flex items-center justify-center text-[16px] hover:border-2 text-white bg-[#65B741] font-bold 
              hover:shadow-2xl hover:shadow-black "
              >
                ثبت
                <CiEdit size={25} className="ml-2" />
              </button>
              <button
                onClick={newSubFun}
                className="w-32 p-2 rounded-full text-[16px] text-white flex items-center justify-center
             bg-[#867AE9] font-bold hover:border-2 hover:shadow-2xl hover:shadow-black font-IranSans"
              >
                جدید <IoNewspaperOutline className="ml-3" />
              </button>
              {/* <button
                    className="w-32 p-2  font-IranSans rounded-full text-[16px] text-white font-bold flex items-center justify-center
             bg-[#F5564E] hover:border-2 hover:shadow-2xl hover:shadow-black"
                  >
                    حذف
                    <MdDeleteForever className="ml-3" />
                  </button> */}
            </div>
          </div>
          {/* </div> */}
          {/* </div> */}
        </div>
        <div className="mt-4">
          <h3 className="font-bold text-center">متن فصل ها</h3>
          <div className="card-with-scroll overflow-x-scroll min-h-30 max-h-40 border border-gray-300 rounded-md mt-1 p-4">
            {chapterSectionText?.map((item, i) => {
              return (
                <p key={i}>
                  {i + 1}... {item.sectionText}
                </p>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default CardMozoatMonaghah;
